var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Label from 'components/v2/forms/Label';
import Select from 'components/v2/select';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const DrayageOperations = ({ data, onUpdateShipper, className }) => {
    const { t } = useTranslation();
    const [initialData, setInitialData] = useState({});
    const [drayageOpsData, setDrayageOpsData] = useState({});
    const getInitialData = () => {
        if (data) {
            setInitialData(data);
            setDrayageOpsData(data);
        }
    };
    useEffect(() => {
        getInitialData();
    }, []);
    const onChange = (field, value) => {
        setDrayageOpsData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const updates = {};
        const { admins } = drayageOpsData, changed = __rest(drayageOpsData, ["admins"]);
        Object.keys(changed).forEach((key) => {
            if (initialData[key] !== changed[key]) {
                updates[key] = changed[key];
            }
        });
        if (Object.keys(updates).length) {
            await onUpdateShipper(updates);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('DRAYAGE_OPERATIONS'), className: classNames(className), canEdit: true }, (editing, saving, onSaveSuccess, onSaveFail) => !editing ? (React.createElement(DrayageOperationsSummary, { fields: initialData })) : (React.createElement(DrayageOperationsForm, { fields: drayageOpsData, onChange: onChange, onSaveShipper: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))));
};
const DrayageOperationsSummary = ({ fields }) => {
    const { t } = useTranslation();
    const { data_entry_agent, customer_success_west, customer_success_central, customer_success_northeast, customer_success_southeast, customer_success_exports, } = fields;
    const na = t('NONE');
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(DescriptionListItem, { label: t('DATA_ENTRY') }, data_entry_agent || na),
        React.createElement(Label, null, t('DRAYAGE_CUSTOMER_SUCCESS_MANAGERS')),
        React.createElement("div", null,
            React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_WEST') }, customer_success_west || na)),
        React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_CENTRAL') }, customer_success_central || na),
        React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_NORTHEAST') }, customer_success_northeast || na),
        React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_SOUTHEAST') }, customer_success_southeast || na),
        React.createElement(DescriptionListItem, { label: t('CUSTOMER_SUCCESS_EXPORTS') }, customer_success_exports || na)));
};
const DrayageOperationsForm = ({ fields, onChange, saving, onSaveShipper, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const { admins } = fields;
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('DATA_ENTRY'), info: t('DATA_ENTRY_TIP'), selected: fields.data_entry_agent, onSelect: ({ slug }) => onChange('data_entry_agent', slug), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Label, null, t('DRAYAGE_CUSTOMER_SUCCESS_MANAGERS')),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('CUSTOMER_SUCCESS_WEST'), info: t('CUSTOMER_SUCCESS_WEST_TIP'), selected: fields.customer_success_west, onSelect: ({ slug }) => onChange('customer_success_west', slug), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('CUSTOMER_SUCCESS_CENTRAL'), info: t('CUSTOMER_SUCCESS_CENTRAL_TIP'), selected: fields.customer_success_central, onSelect: ({ slug }) => onChange('customer_success_central', slug), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('CUSTOMER_SUCCESS_NORTHEAST'), info: t('CUSTOMER_SUCCESS_NORTHEAST_TIP'), selected: fields.customer_success_northeast, onSelect: ({ slug }) => onChange('customer_success_northeast', slug), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('CUSTOMER_SUCCESS_SOUTHEAST'), info: t('CUSTOMER_SUCCESS_SOUTHEAST_TIP'), selected: fields.customer_success_southeast, onSelect: ({ slug }) => onChange('customer_success_southeast', slug), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", label: t('CUSTOMER_SUCCESS_EXPORTS'), info: t('CUSTOMER_SUCCESS_EXPORTS_TIP'), selected: fields.customer_success_exports, onSelect: ({ slug }) => onChange('customer_success_exports', slug), inputClassNames: "lg:w-4/5 w-1/2" })));
};
export default DrayageOperations;
